
import { v4 as uuidv4 } from 'uuid';

// ====================================================
// assignTxIds
//
// assigns fake/temporary transaction id's for optimistic storage
//

export function assignTxnIds(txns) {

  /* eslint-disable no-return-assign */
  return txns.map((txn) => txn.set('id', txn.clientId || `new-${String(uuidv4())}`));
}

// ====================================================
// markTxnsDeleted
//

export function markTxnsDeleted(txns, isDeleted = true) {

  /* eslint-disable no-return-assign */
  return txns.map((txn) => txn.set('isDeleted', isDeleted));
}

